export default "__VITE_ASSET__CIPdkt6r__"